import {Component, ViewChild} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {NgxModalDraggableDirective} from '../../../../directives/draggable.directive';

@Component({
  selector: 'app-modal-chat-detail',
  templateUrl: './modal-chat-detail.component.html',
  styleUrls: ['./modal-chat-detail.component.css']
})
export class ModalChatDetailComponent {
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }

  public data: any;
  constructor(public bsModalRef: BsModalRef) {}
}
